import {ChangeDetectionStrategy, Component, computed, inject, input, output} from '@angular/core';
import {CompetitorArticleData} from "../../types/competitor-article-data.types";
import {defaultCompetitorArticleData} from "../../configs/default-competitor-article-data";
import {MatIcon} from "@angular/material/icon";
import {MatMiniFabButton} from "@angular/material/button";
import {competitorArticleMarketplaceIcon} from "../../configs/competitor-article-marketplace-icon";
import {CompetitorArticlesService} from "../../services/competitor-articles.service";
import {ConfirmService} from "../../../../../../../../core/services/confirm.service";
import {DeleteConfirmationParams} from "../../../../../../../../core/types/confirmation-modal.types";
import {defaultDeleteConfirmationParams} from "../../../../../../../../core/models/default-delete-confirmation-params";

@Component({
  selector: 'app-competitor-articles-accordion-title',
  imports: [
    MatIcon,
    MatMiniFabButton
  ],
  templateUrl: './competitor-articles-accordion-title.component.html',
  styleUrl: './competitor-articles-accordion-title.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompetitorArticlesAccordionTitleComponent {
  competitorArticleData = input<CompetitorArticleData>(defaultCompetitorArticleData);
  isEditModeActive = input<boolean>(false);
  deleteData = output<void>();

  private competitorArticlesService: CompetitorArticlesService = inject(CompetitorArticlesService);
  private confirmService: ConfirmService = inject(ConfirmService);

  public marketplaceIcon = computed(() => {
    const marketplaceType = this.competitorArticleData().marketplaceType;
    return marketplaceType ? competitorArticleMarketplaceIcon[marketplaceType] : '';
  });

  public async handleDeleteData(event: MouseEvent): Promise<void> {
    event.stopPropagation();
    const id = this.competitorArticleData().id;
    const isConfirm = await this.isDeleteConfirmed(id);
    if (!isConfirm) { return; }

    await this.competitorArticlesService.deleteCompetitorArticleData(id)
      .then(() => this.deleteData.emit());
  }

  public async isDeleteConfirmed(recordId: string | number): Promise<boolean> {
    const deleteConfirmationParams: DeleteConfirmationParams = {
      ...defaultDeleteConfirmationParams,
      description: `Вы уверены, что хотите удалить запись №${recordId}?`
    };

    return await this.confirmService.getDeleteConfirmation(deleteConfirmationParams);
  }
}
